/**
 * DogDeRue – scripts de la refonte (Canopy 7.4)
 * - Alerte « Sélectionner une taille » sur le sélecteur
 * - Barre d'achat fixe <dd-sticky-atc>
 * - Date de livraison estimée <dd-delivery>
 * - Pack duo <dd-pack> (ajout du produit complémentaire avant le produit principal)
 * - Clic sur les étoiles = descente vers les avis
 */
(() => {
  if (window.ddRefonteLoaded) return;
  window.ddRefonteLoaded = true;

  const strings = () => Object.assign({ sizeAlert: 'Sélectionner une taille' }, window.ddStrings || {});

  /* ---------- Outils ---------- */

  const headerOffset = () => {
    const value = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-end'));
    return Number.isFinite(value) ? value : 80;
  };

  const scrollToEl = (el) => {
    if (!el) return;
    if (el.closest('quick-add-drawer')) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    const top = el.getBoundingClientRect().top + window.scrollY - headerOffset() - 16;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  };

  const isOptionSelected = (selector) => {
    if (selector.dataset.selectorType === 'dropdown') {
      const opt = selector.querySelector('.custom-select__option[aria-selected="true"]');
      return !!opt && opt.dataset.value !== '';
    }
    return !!selector.querySelector('input:checked');
  };

  const isPreselection = (picker) => {
    if (!picker) return false;
    return [...picker.querySelectorAll('.option-selector:not(.option-selector--custom)')]
      .some((selector) => !isOptionSelected(selector));
  };

  const getSelectedValue = (picker, optionName) => {
    if (!picker || !optionName) return '';
    const selector = [...picker.querySelectorAll('.option-selector')]
      .find((el) => el.dataset.option === optionName);
    if (!selector || selector.querySelectorAll('.js-option').length < 2) return '';
    let value = '';
    if (selector.dataset.selectorType === 'dropdown') {
      const opt = selector.querySelector('.custom-select__option[aria-selected="true"]');
      value = opt ? opt.dataset.value : '';
    } else {
      const input = selector.querySelector('input:checked');
      value = input ? input.value : '';
    }
    const short = value.match(/^[^\s(·–—-]+/);
    return short ? short[0] : value;
  };

  /* ---------- Alerte taille ---------- */

  const clearSizeAlert = (selector) => {
    selector.classList.remove('dd-size-alert');
    const msg = selector.querySelector('.dd-size-alert__msg');
    if (msg) msg.remove();
  };

  const showSizeAlert = (scope) => {
    const picker = scope && scope.querySelector('variant-picker');
    if (!picker) return;
    const target = [...picker.querySelectorAll('.option-selector:not(.option-selector--custom)')]
      .find((selector) => !isOptionSelected(selector));
    if (!target) return;

    let msg = target.querySelector('.dd-size-alert__msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'dd-size-alert__msg';
      msg.setAttribute('role', 'alert');
      const label = target.querySelector('legend, .label');
      const anchor = label ? (label.closest('.flex') || label) : null;
      if (anchor && anchor.parentElement === target) {
        anchor.insertAdjacentElement('afterend', msg);
      } else {
        target.prepend(msg);
      }
    }
    msg.textContent = strings().sizeAlert;

    target.classList.remove('dd-size-alert');
    // Relance l'animation à chaque clic
    void target.offsetWidth; // eslint-disable-line no-void
    target.classList.add('dd-size-alert');
    scrollToEl(target);
  };

  document.addEventListener('change', (evt) => {
    const selector = evt.target.closest && evt.target.closest('.dd-size-alert');
    if (selector) clearSizeAlert(selector);
  });

  // Clic sur le bouton principal grisé (aucune taille choisie) : on montre le sélecteur
  document.addEventListener('click', (evt) => {
    const wrap = evt.target.closest && evt.target.closest('.product-info__add-button');
    if (!wrap) return;
    const btn = wrap.querySelector('button[name="add"]');
    if (!btn || !btn.disabled) return;
    const scope = wrap.closest('.js-product');
    if (scope && isPreselection(scope.querySelector('variant-picker'))) showSizeAlert(scope);
  });

  /* ---------- Étoiles -> avis ---------- */

  document.addEventListener('click', (evt) => {
    const rating = evt.target.closest && evt.target.closest('.cc-main-product .product-info__rating');
    if (!rating) return;
    const reviews = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget, .jdgm-widget.jdgm-all-reviews-widget');
    if (reviews) {
      evt.preventDefault();
      scrollToEl(reviews);
    }
  });

  /* ---------- Barre d'achat fixe ---------- */

  if (!customElements.get('dd-sticky-atc')) {
    class DdStickyAtc extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        this.form = this.section && this.section.querySelector('.js-product-form-main');
        this.btn = this.querySelector('.dd-sticky__btn');
        if (!this.section || !this.form || !this.btn) return;

        this.pastForm = false;
        this.footerVisible = false;
        this.mode = 'choose';

        this.btn.addEventListener('click', this.handleClick.bind(this));

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === this.form) {
              this.pastForm = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            } else {
              this.footerVisible = entry.isIntersecting;
            }
          });
          this.toggle();
        });
        this.observer.observe(this.form);
        const footer = document.querySelector('.shopify-section-group-footer-group, footer');
        if (footer) this.observer.observe(footer);

        const scheduleUpdate = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.update());
        };
        this.productInfo = this.section.querySelector('.product-info');
        if (this.productInfo) {
          this.mutationObserver = new MutationObserver(scheduleUpdate);
          this.mutationObserver.observe(this.productInfo, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['disabled', 'class']
          });
          this.productInfo.addEventListener('change', scheduleUpdate);
        }
        document.addEventListener('on:variant:change', scheduleUpdate);

        // Fin de l'ajout au panier lancé depuis la barre
        const done = (ok) => {
          if (!this.pending) return;
          this.pending = false;
          this.setPending(ok ? 'success' : null);
        };
        document.addEventListener('on:cart:add', () => done(true));
        document.addEventListener('on:line-item:change', () => done(true));
        document.addEventListener('on:cart:error', () => done(false));
        document.addEventListener('dd:pack:error', () => done(false));
        this.update();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mutationObserver) this.mutationObserver.disconnect();
      }

      update() {
        const picker = this.productInfo && this.productInfo.querySelector('variant-picker');
        const addBtn = this.form.querySelector('button[name="add"]');
        const packRadio = this.section.querySelector('dd-pack .dd-pack__radio:checked');
        const packOn = !!(packRadio && packRadio.value);
        let label = packOn && this.dataset.packText ? this.dataset.packText : this.dataset.addText;

        if (picker && isPreselection(picker)) {
          this.mode = 'choose';
          label = this.dataset.chooseText;
        } else if (!addBtn || addBtn.disabled) {
          this.mode = 'unavailable';
          label = addBtn ? addBtn.textContent.trim() : '';
        } else {
          this.mode = 'add';
        }

        if (this.btn.textContent !== label) this.btn.textContent = label;
        this.btn.classList.toggle('btn--primary', this.mode !== 'unavailable');
        this.btn.classList.toggle('btn--secondary', this.mode === 'unavailable');

        // Titre : nom du pack quand il est choisi
        const titleEl = this.querySelector('.dd-sticky__title');
        if (titleEl) {
          const title = packOn && packRadio.dataset.packName ? packRadio.dataset.packName : titleEl.dataset.defaultTitle;
          if (title && titleEl.textContent !== title) titleEl.textContent = title;
        }

        // Prix : total du pack quand il est choisi
        const priceEl = this.querySelector('.dd-sticky__price');
        const packPriceEl = this.querySelector('.dd-sticky__pack-price');
        if (priceEl && packPriceEl) {
          const packItem = packOn ? packRadio.closest('.dd-pack__item') : null;
          const packPrice = packItem ? (packItem.querySelector('.dd-pack__price-final') || packItem.querySelector('.dd-pack__price')) : null;
          packPriceEl.textContent = packPrice ? packPrice.textContent.trim() : '';
          packPriceEl.hidden = !packPrice;
          priceEl.hidden = !!packPrice;
        }

        // Taille choisie à côté du prix
        const sizeEl = this.querySelector('.dd-sticky__size');
        if (sizeEl) {
          const size = this.mode === 'choose' ? '' : getSelectedValue(picker, this.dataset.sizeOption);
          sizeEl.textContent = size ? `${this.dataset.sizeOption} ${size}` : '';
          sizeEl.hidden = !size;
        }
      }

      toggle() {
        const show = this.pastForm && !this.footerVisible;
        this.classList.toggle('is-visible', show);
        this.toggleAttribute('inert', !show);
      }

      // Retour visuel immédiat sur le bouton de la barre (le bouton principal est hors écran)
      setPending(state) {
        clearTimeout(this.pendingTimer);
        if (state === 'loading') {
          this.btn.classList.remove('is-success');
          this.btn.classList.add('is-loading');
          this.btn.setAttribute('aria-disabled', 'true');
          // Sécurité : on libère le bouton si aucune réponse n'arrive
          this.pendingTimer = setTimeout(() => this.setPending(null), 4000);
        } else if (state === 'success') {
          this.btn.classList.add('is-loading', 'is-success');
          this.pendingTimer = setTimeout(() => this.setPending(null), 1200);
        } else {
          this.btn.classList.remove('is-loading', 'is-success');
          this.btn.removeAttribute('aria-disabled');
        }
      }

      handleClick() {
        if (this.btn.getAttribute('aria-disabled') === 'true') return;
        if (this.mode === 'add') {
          const addBtn = this.form.querySelector('button[name="add"]');
          if (addBtn && !addBtn.disabled) {
            this.pending = true;
            this.setPending('loading');
            addBtn.click();
            return;
          }
        }
        if (this.mode === 'choose') {
          showSizeAlert(this.section.querySelector('.product-info'));
          return;
        }
        scrollToEl(this.section.querySelector('.product-info .product-options') || this.form);
      }
    }
    customElements.define('dd-sticky-atc', DdStickyAtc);
  }

  /* ---------- Date de livraison ---------- */

  const easterSunday = (year) => {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
  };

  const dayKey = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

  const holidayCache = {};
  const frenchHolidays = (year) => {
    if (holidayCache[year]) return holidayCache[year];
    const easter = easterSunday(year);
    const plus = (days) => new Date(easter.getFullYear(), easter.getMonth(), easter.getDate() + days);
    const list = [
      new Date(year, 0, 1), plus(1), new Date(year, 4, 1), new Date(year, 4, 8), plus(39), plus(50),
      new Date(year, 6, 14), new Date(year, 7, 15), new Date(year, 10, 1), new Date(year, 10, 11), new Date(year, 11, 25)
    ];
    holidayCache[year] = new Set(list.map(dayKey));
    return holidayCache[year];
  };

  const parseClosedDates = (raw) => {
    const closed = new Set();
    (raw || '').split(',').map((part) => part.trim()).filter(Boolean).forEach((part) => {
      const [from, to] = part.split(':').map((x) => x.trim());
      const start = new Date(`${from}T12:00:00`);
      const end = new Date(`${(to || from)}T12:00:00`);
      if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return;
      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) closed.add(dayKey(d));
    });
    return closed;
  };

  const isWorkingDay = (date, closed) => {
    const day = date.getDay();
    if (day === 0 || day === 6) return false;
    const key = dayKey(date);
    if (frenchHolidays(date.getFullYear()).has(key)) return false;
    return !(closed && closed.has(key));
  };

  const addWorkingDays = (from, count, closed) => {
    const date = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    let added = 0;
    while (added < count) {
      date.setDate(date.getDate() + 1);
      if (isWorkingDay(date, closed)) added += 1;
    }
    // Sans délai, on attend le premier jour ouvré
    while (count === 0 && !isWorkingDay(date, closed)) date.setDate(date.getDate() + 1);
    return date;
  };

  const escapeHtml = (str) => str.replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[c]));

  if (!customElements.get('dd-delivery')) {
    class DdDelivery extends HTMLElement {
      connectedCallback() {
        const num = (key, fallback) => {
          const value = parseInt(this.dataset[key], 10);
          return Number.isFinite(value) ? value : fallback;
        };
        const prepMin = num('prepMin', 1);
        const prepMax = Math.max(num('prepMax', 2), prepMin);
        const shipMin = num('shipMin', 3);
        const shipMax = Math.max(num('shipMax', 5), shipMin);
        const cutoff = num('cutoff', 0);
        const closed = parseClosedDates(this.dataset.closed);
        const template = this.dataset.template;
        const textEl = this.querySelector('.dd-delivery__text');
        if (!template || !textEl) return;

        const now = new Date();
        let orderDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        if (cutoff > 0 && now.getHours() >= cutoff) orderDay.setDate(orderDay.getDate() + 1);
        // Une commande passée un jour non ouvré part le jour ouvré suivant
        if (!isWorkingDay(orderDay, closed)) {
          orderDay = addWorkingDays(orderDay, 0, closed);
        }

        const earliest = addWorkingDays(addWorkingDays(orderDay, prepMin, closed), shipMin, null);
        const latest = addWorkingDays(addWorkingDays(orderDay, prepMax, closed), shipMax, null);

        const sameMonth = earliest.getMonth() === latest.getMonth() && earliest.getFullYear() === latest.getFullYear();
        const fmt = (date, withMonth) => date.toLocaleDateString('fr-FR', withMonth
          ? { weekday: 'long', day: 'numeric', month: 'long' }
          : { weekday: 'long', day: 'numeric' });

        textEl.innerHTML = template
          .replace('[debut]', `<strong>${escapeHtml(fmt(earliest, !sameMonth))}</strong>`)
          .replace('[fin]', `<strong>${escapeHtml(fmt(latest, true))}</strong>`);
      }
    }
    customElements.define('dd-delivery', DdDelivery);
  }

  /* ---------- Pack duo ---------- */

  if (!customElements.get('dd-pack')) {
    class DdPack extends HTMLElement {
      connectedCallback() {
        this.errorEl = this.querySelector('.dd-pack__error');
        this.productInfo = this.closest('.product-info');
        this.addEventListener('change', (evt) => {
          if (evt.target.matches('.dd-pack__radio, .dd-pack__select')) {
            this.hideError();
            this.syncState();
            this.applyAtcLabel();
            this.applyDeliveryOffer();
          }
        });
        this.syncState();
        this.applyDeliveryOffer();

        // Le thème réécrit le bouton à chaque changement de taille : on remet le libellé du pack
        if (this.productInfo) {
          this.mutationObserver = new MutationObserver(() => {
            cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => {
              this.applyAtcLabel();
              this.applyDeliveryOffer();
            });
          });
          this.mutationObserver.observe(this.productInfo, {
            subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled']
          });
        }
      }

      disconnectedCallback() {
        if (this.mutationObserver) this.mutationObserver.disconnect();
      }

      isPackSelected() {
        const radio = this.querySelector('.dd-pack__radio:checked');
        return !!(radio && radio.value);
      }

      // Ligne « Point relais offert dès 70 € » de la date de livraison :
      // passe à « Livraison offerte » quand le pack choisi dépasse le seuil
      applyDeliveryOffer() {
        const offer = this.productInfo && this.productInfo.querySelector('.dd-delivery__offer');
        const radio = this.querySelector('.dd-pack__radio:checked');
        if (!offer || !radio) return;
        const min = parseInt(offer.dataset.freeMin, 10);
        const total = parseInt(radio.dataset.totalCents, 10);
        if (!Number.isFinite(min) || !Number.isFinite(total) || min <= 0) return;
        const free = total >= min;
        const freeEl = offer.querySelector('.dd-delivery__offer-free');
        const thresholdEl = offer.querySelector('.dd-delivery__offer-threshold');
        if (freeEl && freeEl.hidden === free) freeEl.hidden = !free;
        if (thresholdEl && thresholdEl.hidden !== free) thresholdEl.hidden = free;
      }

      applyAtcLabel() {
        const packText = this.dataset.atcText;
        const btn = this.productInfo && this.productInfo.querySelector('.js-product-form-main button[name="add"]');
        if (!btn || !packText || btn.disabled) return;
        const wanted = this.isPackSelected() ? packText : btn.dataset.addToCartText;
        if (wanted && btn.textContent.trim() !== wanted) btn.textContent = wanted;
      }

      syncState() {
        this.querySelectorAll('.dd-pack__item').forEach((item) => {
          item.classList.toggle('is-selected', !!item.querySelector('.dd-pack__radio:checked'));
        });
      }

      getAddon() {
        const radio = this.querySelector('.dd-pack__radio:checked');
        if (!radio || !radio.value) return null;
        const item = radio.closest('.dd-pack__item');
        const select = item.querySelector('.dd-pack__select');
        return { variantId: select ? select.value : radio.dataset.variantId, select };
      }

      showError(message, focusEl) {
        document.dispatchEvent(new CustomEvent('dd:pack:error'));
        if (!this.errorEl) return;
        this.errorEl.textContent = message || this.dataset.errorVariant;
        this.errorEl.hidden = false;
        scrollToEl(this);
        if (focusEl) setTimeout(() => focusEl.focus(), 400);
      }

      hideError() {
        if (this.errorEl) this.errorEl.hidden = true;
      }
    }
    customElements.define('dd-pack', DdPack);
  }

  /* ---------- Achat rapide lancé depuis le panier : retour au panier ---------- */
  // Quand on choisit une taille pour un produit suggéré dans le panier, le thème ferme le panier
  // et ouvre l'achat rapide. Après l'ajout (ou si on ferme l'achat rapide), on rouvre le panier
  // au lieu de laisser le client sur la page produit d'origine.

  let ddQuickFromCart = false;

  document.addEventListener('click', (evt) => {
    const btn = evt.target.closest && evt.target.closest('.js-quick-add');
    if (!btn) return;
    const cart = document.querySelector('cart-drawer');
    ddQuickFromCart = !!(btn.closest('cart-drawer') || (cart && cart.getAttribute('aria-hidden') === 'false'));
  }, true);

  const initQuickReturn = () => {
    const quick = document.querySelector('quick-add-drawer');
    if (!quick || quick.dataset.ddReturnInit) return;
    quick.dataset.ddReturnInit = 'true';

    const reopenCart = () => {
      const cart = document.querySelector('cart-drawer');
      if (cart && typeof cart.open === 'function' && cart.getAttribute('aria-hidden') !== 'false') cart.open();
    };

    // Fermeture de l'achat rapide (après ajout ou par la croix) : retour au panier
    new MutationObserver(() => {
      if (quick.getAttribute('aria-hidden') === 'true' && ddQuickFromCart) {
        ddQuickFromCart = false;
        setTimeout(reopenCart, 200);
      }
    }).observe(quick, { attributes: true, attributeFilter: ['aria-hidden'] });

    // Ajout réussi depuis l'achat rapide : on laisse voir la confirmation puis on revient au panier
    const afterAdd = () => {
      if (!ddQuickFromCart) return;
      setTimeout(() => {
        if (quick.getAttribute('aria-hidden') === 'false' && typeof quick.close === 'function') quick.close();
      }, 1000);
    };
    quick.addEventListener('on:cart:add', afterAdd);
    quick.addEventListener('on:line-item:change', afterAdd);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickReturn);
  } else {
    initQuickReturn();
  }

  /* ---------- Code promo dans le tiroir panier ---------- */

  const cartRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const currentCodes = (scope) => [...scope.querySelectorAll('.dd-promo__chip[data-code]')]
    .map((chip) => chip.dataset.code)
    .filter(Boolean);

  const updateDiscounts = async (codes) => {
    const response = await fetch(`${cartRoot()}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    });
    if (!response.ok) throw new Error(String(response.status));
    return response.json();
  };

  const refreshDrawer = async () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.refreshCartDrawer === 'function') {
      await drawer.refreshCartDrawer(true);
    } else {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    }
  };

  const showPromoError = (message) => {
    const promo = document.querySelector('.dd-promo');
    if (!promo) return;
    const details = promo.querySelector('.dd-promo__details');
    const errorEl = promo.querySelector('.dd-promo__error');
    if (details) details.open = true;
    if (errorEl) {
      errorEl.textContent = message || promo.dataset.error;
      errorEl.hidden = false;
    }
  };

  document.addEventListener('submit', async (evt) => {
    const form = evt.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('dd-promo__form')) return;
    evt.preventDefault();
    const promo = form.closest('.dd-promo');
    const input = form.querySelector('.dd-promo__input');
    const btn = form.querySelector('.dd-promo__apply');
    const code = input ? input.value.trim() : '';
    if (!promo || !code) return;

    const existing = currentCodes(promo);
    const codes = [...new Set([...existing, code])];
    if (btn) btn.classList.add('is-loading');

    try {
      const cart = await updateDiscounts(codes);
      let applicable = true;
      if (Array.isArray(cart.discount_codes)) {
        const found = cart.discount_codes.find((d) => d.code && d.code.toLowerCase() === code.toLowerCase());
        applicable = !!(found && found.applicable);
      }
      if (!applicable) {
        // On retire le code refusé pour ne pas le laisser traîner dans le panier
        await updateDiscounts(existing);
        await refreshDrawer();
        showPromoError();
        return;
      }
      await refreshDrawer();
    } catch (error) {
      showPromoError();
    } finally {
      if (btn) btn.classList.remove('is-loading');
    }
  });

  document.addEventListener('click', async (evt) => {
    const removeBtn = evt.target.closest && evt.target.closest('.dd-promo__remove');
    if (!removeBtn) return;
    evt.preventDefault();
    const promo = removeBtn.closest('.dd-promo');
    const chip = removeBtn.closest('.dd-promo__chip');
    if (!promo || !chip) return;
    const remaining = currentCodes(promo).filter((c) => c !== chip.dataset.code);
    chip.classList.add('is-loading');
    try {
      await updateDiscounts(remaining);
    } catch (error) {
      // on rafraîchit quand même pour afficher l'état réel du panier
    }
    await refreshDrawer();
  });

  // Interception de l'ajout au panier principal quand un duo est choisi :
  // 1. ajout du produit complémentaire, 2. ajout normal du produit principal par le thème
  // (le tiroir panier s'ouvre alors avec les deux articles).
  document.addEventListener('submit', async (evt) => {
    const form = evt.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('js-product-form-main')) return;
    if (form.dataset.ddPackPass === '1') {
      delete form.dataset.ddPackPass;
      return;
    }
    const section = form.closest('.shopify-section');
    const pack = section && section.querySelector('dd-pack');
    if (!pack || typeof pack.getAddon !== 'function') return;
    const addon = pack.getAddon();
    if (!addon) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();

    if (!addon.variantId) {
      pack.showError(pack.dataset.errorVariant, addon.select);
      return;
    }

    const btn = form.querySelector('button[name="add"]');
    if (btn) btn.classList.add('is-loading');

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(addon.variantId), quantity: 1 }] })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || '');

      if (btn) btn.classList.remove('is-loading');
      form.dataset.ddPackPass = '1';
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(btn || undefined);
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    } catch (error) {
      if (btn) btn.classList.remove('is-loading');
      pack.showError(error.message);
    }
  }, true);
})();

/* ==========================================================================
   Appli Notify Me : repère le bouton « M'avertir du retour » dans la fiche
   (quel que soit son nom de classe) pour que le CSS ne l'affiche que si la
   taille cochée est épuisée. Voir dogderue-custom.css, section 13.
   ========================================================================== */
(() => {
  const RX = /m['’]?\s?avertir|pr[ée]venez[- ]moi|notify me|retour en stock/i;
  const SKIP = '[name="add"], dd-pack, dd-sticky-atc, .dd-size-info, .dd-delivery, .dd-notify';

  const tag = () => {
    document.querySelectorAll('.js-product').forEach((product) => {
      product.querySelectorAll('button, a, [role="button"], input[type="button"], input[type="submit"]').forEach((el) => {
        if (el.closest(SKIP)) return;
        const label = (el.value || el.textContent || '').trim();
        if (!label || label.length > 60 || !RX.test(label)) return;
        // Si l'appli enveloppe son bouton dans un bloc qui ne contient que lui, on masque le bloc entier
        const parent = el.parentElement;
        const target = parent && parent.children.length === 1 && !parent.matches('form, .js-product, .product-info, .product-info__block')
          ? parent : el;
        target.classList.add('dd-notify');
      });
    });
  };

  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; tag(); });
  };

  const start = () => {
    if (!document.querySelector('.js-product .dd-opt-size')) return;
    tag();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
